export default "__VITE_ASSET__53cd6acc__"